import * as actions from './actions';
import * as api from './api';
import enterReducer from './enter.reducer';
import * as functions from './functions';
import reducer from './reducer';

const reducers = {
  eventEnter: enterReducer,
  event: reducer,
};

export {
 api, reducers, actions, functions,
};
